import {
    Frame,
    Button,
    Page,
    Loading,
    Layout,
    ResourceList,
    ResourceItem,
    LegacyCard,
    Badge,
    Pagination,
    Text,
} from "@shopify/polaris";
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Api from '../../helpers/api';

function DiscountBadges ({ item }) {
    const list = [];

    if (item.configuration.type === 'decrease') {
        list.push(
            item.configuration.by.type === 'percentage'
                ? <Badge size='small'>{item.configuration.by.amount}%</Badge>
                : <Badge size='small'>${item.configuration.by.amount}</Badge>
        )
    }

    if (item.configuration.type === 'free_other_collection') {
        list.push(<Badge size='small'>Free Items From Other Collection</Badge>)
    }

    if (item.configuration.type === 'collection_flat_rate') {
        list.push(<Badge size='small'>Collection Flat Rate</Badge>)
    }

    if (item.configuration.type === 'bogo') {
        list.push(<Badge size='small'>BOGO</Badge>)
    }

    if (item.one_time_per_customer) {
        list.push(<Badge size='small'>One Time Per Customer</Badge>);
    }

    if (item.configuration.eligible_products) {
        list.push(<Badge size='small'>Eligible Products</Badge>)
    }

    return list;
}

export default () => {
    const history = useHistory();
    const showCreatePage = useCallback(() => {
        history.push('/discount-codes/create');
    }, []);

    const [discountCodes, setDiscountCodes] = useState([]);
    const [meta, setMeta] = useState({
        loading: false,
        page: 1,
        totalPages: null,
    });

    useEffect(() => {
        setMeta({
            ...meta,
            loading: true,
        });

        Api.listDiscountCodes(meta.page)
            .then(response => {
                setDiscountCodes(response.data.data);
                setMeta({
                    ...meta,
                    totalPages: response.data.meta.last_page,
                    loading: false,
                });
            });
    }, [meta.page]);

    return (
        <Frame>
            {meta.loading && <Loading />}

            <Page title="Discount Codes"
                  primaryAction={<Button  onClick={showCreatePage} variant="primary">New Code</Button>}>

                <Layout>
                    <Layout.Section>
                        <LegacyCard>
                            <ResourceList
                                resourceName={{ singular: 'discount code', plural: 'discount codes' }}
                                items={discountCodes}
                                renderItem={(item) => (
                                    <ResourceItem
                                        id={item.id}
                                        onClick={() => history.push(`/discount-codes/${item.id}/edit`)}
                                    >
                                        <h3>
                                            <Text  variant="bodyMd" as="span" fontWeight="semibold">{item.code ?? item.name}</Text>
                                        </h3>
                                        <div style={{marginTop: '1rem', display: 'inline-flex', gap: '1rem'}}>
                                            <DiscountBadges item={item} />
                                        </div>
                                    </ResourceItem>
                                )}
                            />
                            {meta.totalPages > 1 && (
                                <LegacyCard.Section>
                                    <Pagination label={`Showing Page ${meta.page} of ${meta.totalPages}`}
                                                hasPrevious={ meta.page > 1}
                                                onPrevious={() => setMeta(state => ({ ...state, page: state.page - 1 }))}
                                                hasNext={ meta.page < meta.totalPages }
                                                onNext={() => setMeta(state => ({ ...state, page: state.page + 1 }))} />
                                </LegacyCard.Section>
                            )}
                        </LegacyCard>
                    </Layout.Section>
                </Layout>
            </Page>
        </Frame>
    );
}
